var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 22.726c6.1 0 11.044-4.945 11.044-11.044 0-6.1-4.944-11.045-11.044-11.045C5.854.637.909 5.582.909 11.68c0 6.1 4.945 11.045 11.045 11.045zm0-2.439a8.606 8.606 0 1 1 0-17.211 8.606 8.606 0 0 1 0 17.211z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.214 20.029 6.095 5.731a1.22 1.22 0 0 0 1.67-1.777l-6.094-5.731a1.22 1.22 0 0 0-1.671 1.777z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2-icon.4baa56aa564b741b3c882fef6b80c46b.svg";
export { ForwardRef as ReactComponent };